<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" class=" font-weight-bold text-capitalize light--text" color="primary"> <v-icon class="me-1" small>mdi-plus</v-icon> Add </v-btn>
      </template>
      <v-card color="pop_bg">
        <v-card-title>
          <span class="text-h6 dark--text">Add HomePage Package</span>
          <v-spacer></v-spacer>
          <v-btn color="dark" text @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container class="mt-2">
            <v-form @submit="updateFaq()" v-model="valid" ref="form">
              <v-row>
                <v-col cols="12" sm="6">
                  <h4 class="mb-2 text-body-2 dark--text">Select Package</h4>
                  <v-autocomplete
                    item-text="titleEn"
                    v-model="selectedPackage"
                    item-value="_id"
                    :items="packagesList"
                    :rules="[requiredValidator('package ')]"
                    placeholder="Select package"
                    dense
                    solo
                    return-object
                  >
                    <template slot="no-data">
                      <v-flex xs12 md12 class="mt-2 mb-2">
                        <h5 class="ml-4 font-weight-medium">
                          Search for package...
                        </h5>
                      </v-flex>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                  <h4 class="mb-2 text-body-2 dark--text">Display Type</h4>
                  <v-select :items="['PRIMARY', 'SECONDARY']" v-model="planShowType" label="Select" dense solo></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <h4 class="mb-2 text-body-2 dark--text">Price</h4>
                  <v-text-field solo name="input-7-4" type="number" label="Price" v-model="price"></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Image</h4>
                  <input type="file" accept="image/*" @change="onFileSelected($event)" />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-snackbar v-model="snackbar" :timeout="3000" :color="snackColor">
                    {{ snackText }}
                  </v-snackbar>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Image for Mobile</h4>
                  <input type="file" accept="image/*" @change="onFileSelectedMob($event)" />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-snackbar v-model="snackbar" :timeout="3000" :color="snackColor">
                    {{ snackText }}
                  </v-snackbar>
                </v-col>
              </v-row>

              <v-row v-show="planShowType === 'SECONDARY'">
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Show Order</h4>
                  <v-text-field solo name="input-7-4" label="Show Order" v-model="showOrder"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-checkbox label="Modify Card Colors" v-model="modifyColor"></v-checkbox>
              </v-row>

              <v-row v-if="modifyColor">
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Background Color</h4>
                  <v-text-field v-model="color1" @click="showMenu1()" label="Click to select color"> </v-text-field>
                  <v-menu v-model="menu1" :close-on-content-click="false" :nudge-width="200" offset-y>
                    <v-card>
                      <v-card-text>
                        <v-row>
                          <v-color-picker v-model="color1" flat @input="setColor1"></v-color-picker>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Heading Text Color</h4>
                  <v-text-field v-model="color2" @click="showMenu2()" label="Click to select color"> </v-text-field>
                  <v-menu v-model="menu2" :close-on-content-click="false" :nudge-width="200" offset-y>
                    <v-card>
                      <v-card-text>
                        <v-row>
                          <v-color-picker v-model="color2" flat @input="setColor2"></v-color-picker>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Boarder Color</h4>
                  <v-text-field v-model="color3" @click="showMenu3()" label="Click to select color"> </v-text-field>
                  <v-menu v-model="menu3" :close-on-content-click="false" :nudge-width="200" offset-y>
                    <v-card>
                      <v-card-text>
                        <v-row>
                          <v-color-picker v-model="color3" flat @input="setColor3"></v-color-picker>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Button Fill Color</h4>
                  <v-text-field v-model="color4" @click="showMenu4()" label="Click to select color"> </v-text-field>
                  <v-menu v-model="menu4" :close-on-content-click="false" :nudge-width="200" offset-y>
                    <v-card>
                      <v-card-text>
                        <v-row>
                          <v-color-picker v-model="color4" flat @input="setColor4"></v-color-picker>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <h4 class="text-body-2 dark--text">Button Boarder Color</h4>
                  <v-text-field v-model="color5" @click="showMenu5()" label="Click to select color"> </v-text-field>
                  <v-menu v-model="menu5" :close-on-content-click="false" :nudge-width="200" offset-y>
                    <v-card>
                      <v-card-text>
                        <v-row>
                          <v-color-picker v-model="color5" flat @input="setColor5"></v-color-picker>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions class="justify-end mt-n8">
          <v-btn
            color="primary"
            class="mb-2 light--text mb-sm-4 text-capitalize"
            :width="$vuetify.breakpoint.smAndUp ? 120 : 90"
            @click="createWebHomePackage"
            :loading="btnloading"
            :disabled="!valid"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
import { requiredValidator } from "../../core/methods/validations";

export default {
  data() {
    return {
      btnloading: false,
      valid: true,
      errors: [],
      snackbar: false,
      snackColor: "",
      snackText: "",
      text: "",
      planShowType: "",
      price: "",
      selectedPackage: "",
      image: null,
      imageMob: null,
      isActive: false,
      show_dialog_box: false,
      requiredValidator: requiredValidator,
      packagesList: [],
      showOrder: "",
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      color1: "",
      color2: "",
      color3: "",
      color4: "",
      color5: "",
      modifyColor: false,
    };
  },
  props: {
    data: Object,
  },
  apollo: {
    getAllPackages() {
      return {
        query: require("@/menu-packages/api/getAllPackages.graphql"),
        variables: this.variables,
        result({ data, loading }) {
          this.loading = loading;
          this.packagesList = data.getAllPackages.packages.filter(x => x.active == true);
        },
      };
    },
  },
  methods: {
    showMenu1() {
      this.menu1 = true;
    },
    showMenu2() {
      this.menu2 = true;
    },
    showMenu3() {
      this.menu3 = true;
    },
    showMenu4() {
      this.menu4 = true;
    },
    showMenu5() {
      this.menu5 = true;
    },

    setColor1(color) {
      this.color1 = color;
    },
    setColor2(color) {
      this.color2 = color;
    },
    setColor3(color) {
      this.color3 = color;
    },
    setColor4(color) {
      this.color4 = color;
    },
    setColor5(color) {
      this.color5 = color;
    },

    close() {
      this.show_dialog_box = false;
    },
    onFileSelected(event) {
      const selectedFile = event.target.files[0];
      this.image = selectedFile;
    },
    onFileSelectedMob(event) {
      const selectedFile = event.target.files[0];
      this.imageMob = selectedFile;
    },
    createWebHomePackage() {
      debugger;

      if (!this.image) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Please choose an image";
        return;
      }
      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: require("../api/createWebHomePackage.graphql"),
          variables: {
            planShowType: this.planShowType,
            price: parseFloat(this.price ? this.price : 0),
            package: this.selectedPackage._id,
            image: this.image,
            imageMob: this.imageMob,
            showOrder: parseInt(this.showOrder),
            color1: this.color1,
            color2: this.color2,
            color3: this.color3,
            color4: this.color4,
            color5: this.color5,
            modifyColor: this.modifyColor,
          },
          update: () => {
            this.text = "Package Details  Added";
            this.snackbar = true;
            this.btnloading = false;
            this.$root.$emit("updateHomePackage");
            this.show_dialog_box = false;
            this.$refs.form.reset();
          },
          // update: (store, { data: { createWebHomePackage } }) => {
          //   try {
          //     // const query = {
          //     //   query: require("../api/getPaymentGatewayCharges.graphql"),
          //     // };

          //     // let allData = store.readQuery(query);

          //     // allData.getPaymentGatewayCharges.unshift(createPaymentGatewayCharge); //push to top
          //     // store.writeQuery({
          //     //   ...query,
          //     //   data: allData,
          //     // });

          //     this.text = "Package Details  Added";
          //     this.snackbar = true;
          //     this.btnloading = false;
          //     this.show_dialog_box = false;
          //     this.$refs.form.reset();
          //   } catch (e) {
          //     console.log("Something bad happend");
          //     console.log(e);
          //     this.btnloading = false;
          //   }

          //   this.show_dialog_box = false;
          //   this.btnloading = false;
          // },
        })

        .catch(error => {
          if (error.graphQLErrors != null) {
            this.text = error.graphQLErrors[0].message;
            this.snackbar = true;
            console.error();
          }
          this.btnloading = false;
          this.show_dialog_box = false;
        });
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}
</style>
